import { 
    createStore, 
    combineReducers, 
    applyMiddleware, 
    compose } from 'redux';
import thunk from 'redux-thunk';
import Cookies from 'js-cookie';
// import {
//   productListReducer,
//   productDetailsReducer,
//   productSaveReducer,
//   productDeleteReducer,
//   productReviewSaveReducer,
// } from './reducers/productReducers';
// import { cartReducer } from './reducers/cartReducers';
import {
  contributorLoginReducer,
  contributorRegisterReducer,
  forgotPasswordReducer,
  sendResetPasswordReducer,
  resetPasswordReducer,
  getContributorRolesReducer
//   userRegisterReducer,
//   userUpdateReducer,
} from './reducers/contributor/contributorAuthReducer';
import {
  createContributorProfileReducer,
  getContributorProfileReducer
} from './reducers/contributor/contributorProfileReducer';
import {
    homeReducer,
} from './reducers/homeReducer';

// import {
//   orderCreateReducer,
//   orderDetailsReducer,
//   orderPayReducer,
//   myOrderListReducer,
//   orderListReducer,
//   orderDeleteReducer,
// } from './reducers/orderReducers';

// const cartItems = Cookie.getJSON('cartItems') || [];
const userInfo = Cookies.getJSON('userInfo') || null;

const initialState = {
//   cart: { cartItems, shipping: {}, payment: {} },
  userSignin: { userInfo },
};
const reducer = combineReducers({
//   productList: productListReducer,
//   productDetails: productDetailsReducer,
//   cart: cartReducer,
    userSignin: contributorLoginReducer,
    userRegister: contributorRegisterReducer,
    forgotPassword: forgotPasswordReducer,
    signedinUser: homeReducer,
    sendResetPassword: sendResetPasswordReducer,
    resetPassword: resetPasswordReducer,
    createProfile: createContributorProfileReducer,
    getProfile: getContributorProfileReducer,
    getContributorRoles: getContributorRolesReducer
//   userRegister: userRegisterReducer,
//   productSave: productSaveReducer,
//   productDelete: productDeleteReducer,
//   productReviewSave: productReviewSaveReducer,
//   orderCreate: orderCreateReducer,
//   orderDetails: orderDetailsReducer,
//   orderPay: orderPayReducer,
//   userUpdate: userUpdateReducer,
//   myOrderList: myOrderListReducer,
//   orderList: orderListReducer,
//   orderDelete: orderDeleteReducer,
});
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducer,
  initialState,
  composeEnhancer(applyMiddleware(thunk))
);
export default store;
